module.exports = __webpack_public_path__ + "img/burger.93788e13.svg";